
import { LockDec, ValidateDec } from '@/decorators'
import { Component, Prop, Vue } from 'vue-facing-decorator'

@Component({})
export default class extends Vue {
  /** 当前要改的商品行 */
  @Prop()
  modelValue: any

  /** popover 给的关闭方法，改完要主动收起 */
  @Prop()
  hideEvent: any

  postData = {
    sort: '',
  }

  submitLoading = false;

  created() {
    this.postData.sort = this.modelValue.sort ?? 0;
  }

  /** 规则和后端 GoodsBaseOperatDto 的 sort 对齐：0-999999 的整数 */
  validateSort(v) {
    if (v === '' || v === null || v === undefined) throw '请输入排序';
    if (!/^\d+$/.test(String(v))) throw '排序只能填写非负整数';
    if (Number(v) > 999999) throw '排序超出范围';
  }

  @LockDec('submitLoading')
  @ValidateDec('form')
  async confirm() {
    /** 排序是直接覆盖，不做加减，传绝对值就行。base-operat 是「传了哪个改哪个」，不带别的字段 */
    await this.$postNotify('/manager/goods/base-operat', {
      id: this.modelValue.id,
      sort: Number(this.postData.sort),
    })
    /** 改完直接收起整个 popover */
    if (this.hideEvent) this.hideEvent();
    this.$emit('success');
  }

  /** 取消只是退回列表，不关 popover */
  cancel() {
    this.$emit('back');
  }
}
